import {
  DropdownMenuCheckboxItem,
  DropdownMenuGroup,
  DropdownMenuSeparator,
} from "../../../ui/dropdown-menu";
import { CheckboxGroupType, CheckboxItemType } from "../types";

const CheckboxItem = ({ checkboxItem }: { checkboxItem: CheckboxItemType }) => {
  return (
    <DropdownMenuCheckboxItem
      className="gap-2 m-0 rounded-none py-1.5 pl-3 pr-9 outline-none"
      checked={checkboxItem.checked}
      onCheckedChange={checkboxItem.onSelect}
      disabled={checkboxItem.disabled}
      onSelect={event => event.preventDefault()}
    >
      {checkboxItem.icon}
      {checkboxItem.label}
    </DropdownMenuCheckboxItem>
  );
};

export const CheckboxGroup = ({
  checkboxGroupItem,
}: {
  checkboxGroupItem: CheckboxGroupType;
}) => {
  return (
    <>
      <DropdownMenuGroup>
        {checkboxGroupItem.checkboxes.map((checkboxItem, index) => (
          <CheckboxItem key={`item-${index}`} checkboxItem={checkboxItem} />
        ))}
      </DropdownMenuGroup>
      {checkboxGroupItem.separator && <DropdownMenuSeparator />}
    </>
  );
};
